import { mediaApi, itemsAPI} from '../api/api';
import { showNotification } from '../parts/Admin/utils/notifications/notifications';

const SET_ITEMS_QUESTIONS = 'SET_ITEMS_QUESTIONS';
const SET_EDITING_ITEM_ID = 'SET_EDITING_ITEM_ID';
const REMOVE_EDITING_ITEM_ID = 'REMOVE_EDITING_ITEM_ID';
const UPDATE_QUESTIONS_POSITION = 'UPDATE_QUESTIONS_POSITION';
const SET_EXISTING_IMAGES = 'SET_EXISTING_IMAGES';
const SET_QUESTION_CREATION_TYPE = 'SET_QUESTION_CREATION_TYPE';
const SET_STEP = 'SET_STEP';
const SET_QUESTIONS_LIST = 'SET_QUESTIONS_LIST';
const SET_LOADING_STATE = 'SET_LOADING_STATE';
const QUESTION_CREATION_START = 'QUESTION_CREATION_START';
const QUESTION_CREATION_END = 'QUESTION_CREATION_END';
const DELETE_QUESTION = 'DELETE_QUESTION';
const SET_QUESTION_QUIZ = 'SET_QUESTION_QUIZ';
const UPDATE_QUESTION_QUIZ = 'UPDATE_QUESTION_QUIZ';
const DELETE_QUESTION_QUIZ = 'DELETE_QUESTION_QUIZ';

const ENTITY = 'quizzes';


const initialState = {
    activeItemId: null,
    newQuestionCreation: false,
    questionCreationActiveStep: 2,
    questionCreationType: 'question',
    itemsLoading: true,
    items: [],
    existingImages: []
};

const quizzesComponentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_QUESTIONS_LIST:
            return {
                ...state,
                items: action.payload
            };
        case SET_LOADING_STATE:
            return {
                ...state,
                itemsLoading: action.payload
            };
        case SET_ITEMS_QUESTIONS:
            return {
                ...state,
                items: action.payload
            };
        case SET_EDITING_ITEM_ID:
            return {
                ...state,
                activeItemId: action.payload
            };
        case `SET_QUESTION_QUIZ`:
            const tmpState = {
                ...state
            }
            tmpState.items.push(action.payload);

            return {
                ...state,
                items: [...tmpState.items]
            };
        case `UPDATE_QUESTION_QUIZ`:
            const tmpState1 = {
                ...state
            }
            const newField = tmpState1.items.find(field => field.id === action.payload.id)
            const index = tmpState1.items.indexOf(newField)
            newField.name = action.payload.name
            newField.type = action.payload.type
            newField.content = action.payload.content
            newField.id = action.payload.id
            newField.position = action.payload.position

            tmpState1.items[index] = newField
            return {
                ...state,
                items: [...tmpState1.items]
            }
        case `DELETE_QUESTION_QUIZ`:
            const tmpState2 = {
                ...state
            }
            const newFields = tmpState2.items.filter((field) => field.id !== action.payload);
            tmpState2.items = newFields
            return {
                ...state,
                items: [...tmpState2.items]
            }
        case REMOVE_EDITING_ITEM_ID:
            return {
                ...state,
                activeItemId: null
            };
        case QUESTION_CREATION_START:
            return {
                ...state,
                newQuestionCreation: true
            };
        case UPDATE_QUESTIONS_POSITION:
            return {
                ...state,
                items: action.payload.map((item, index) => {
                    item.position = index;
                    return item;
                })
            };
        case SET_EXISTING_IMAGES:
            return {
                ...state,
                existingImages: action.payload
            };
        case QUESTION_CREATION_END:
            return {
                ...state,
                newQuestionCreation: false,
                questionCreationActiveStep: 2,
                questionCreationType: 'question'
            };
        case SET_QUESTION_CREATION_TYPE:
            return {
                ...state,
                questionCreationType: action.questionType
            };
        case SET_STEP:
            return {
                ...state,
                questionCreationActiveStep: action.step
            };

        case DELETE_QUESTION:
            return {
                ...state,
                items: state.items.filter((_, index) => index !== action.payload)
            };
        default:
            return state;
    }
};


export const setQuestionsList = (questions) => ({
    type: SET_QUESTIONS_LIST,
    payload: questions
});

export const setQuestionQuiz = (data) => ({
    type: SET_QUESTION_QUIZ,
    payload: data
});

export const updateQuestionQuiz = (data) => ({
    type: UPDATE_QUESTION_QUIZ,
    payload: data
});

export const deleteQuestionQuiz = (data) => ({
    type: DELETE_QUESTION_QUIZ,
    payload: data
});

export const setEditingItemId = (questionId) => ({
    type: SET_EDITING_ITEM_ID,
    payload: questionId
});

export const removeEditingItemId = () => ({
    type: REMOVE_EDITING_ITEM_ID
});

export const startQuestionCreation = () => ({
    type: QUESTION_CREATION_START
});

export const endQuestionCreation = () => ({
    type: QUESTION_CREATION_END
});

export const setStep = (step) => ({
    type: SET_STEP,
    step
});

export const setQuestionCreationType = (questionType) => ({
    type: SET_QUESTION_CREATION_TYPE,
    questionType
});

export const setLoadingState = (bool) => ({
    type: SET_LOADING_STATE,
    payload: bool
});

export const deleteItemByIndex = (index) => ({
    type: DELETE_QUESTION,
    payload: index
});

export const updateQuestionsPosition = (items) => ({
    type: UPDATE_QUESTIONS_POSITION,
    payload: items
});

export const setExistingImages = (payload) => ({
    type: SET_EXISTING_IMAGES,
    payload
});

export const fetchQuestions = (quizId) => {
    return async (dispatch) => {
        try {
            const response = await itemsAPI.getItemData(ENTITY, quizId);

            dispatch(setQuestionsList(response.items || []));
        } catch (error) {
            console.log(error);
            dispatch(setQuestionsList([]));
        } finally {
            dispatch(setLoadingState(false));
        }
    };
};

export const fetchExistingImages = () => {
    return async (dispatch) => {
        try {
            const response = await mediaApi.getMedia();

            dispatch(setExistingImages(response));
        } catch (error) {
            (error.response?.data.message).forEach((value, i) => {
                showNotification(error.response?.data.message[i], 'danger');
            });
        }
    };
};


export const deleteItem = (index) => {
    return async (dispatch) => {
        try {
            dispatch(deleteItemByIndex(index));
        } catch (error) {
            if (error.response?.data?.message) {
                showNotification(error.response.data.message, 'danger', 'shifted');
            } else {
                showNotification('Some error occurred', 'danger', 'shifted');
            }
            console.log(error);
        } finally {
        }
    };
};

export default quizzesComponentsReducer;
